import { FlatButton } from "material-ui";
import * as React from "react";

const Admin = () => {
  async function cchAdminLoginHandler() {
    console.log("Inside code-state handler");

    window.location.href = `https://login.cchaxcess.com/ps/auth/v1.0/core/connect/authorize?response_type=code&client_id=493b907f-f58e-7f5e-2c3d-abbecff1200b&redirect_uri=${process.env.BASE_URL}/Home&scope=CCHAxcess_ADSync_writeaccess CCHAxcess_data_writeaccess CCHAxcess_Profile IDInfo offline_access openid`;
  }
  return (
    <FlatButton
      onClick={cchAdminLoginHandler}
      className="flatButtonCls"
      style={{ width: "120px", top: "35vh", left: "45%" }}
    >
      Go To Admin
    </FlatButton>
  );
};
export default Admin;



// WEBPACK FOOTER //
// ./app/components/Administration/Admin.js